import React, { useEffect, useState, useMemo } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import classes from "./Chart.module.css";
import { LegendNodeIcon } from "../../constant";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

/**
 * A reusable chart component for displaying line charts
 * @param {Object} props - Component props
 * @returns {JSX.Element} Chart component
 */
const Chart = ({
  externalData = null,
  externalLabels = null,
  height = 300,
  data = null,

  loading = false,
}) => {
  console.log("ata Chart", data);
  const [datasets, setDatasets] = useState([]);
  const [labels, setLabels] = useState([]);
  useEffect(() => {
    if (data) {
      let tempDatasets = [];

      data?.lines?.forEach((line) => {
        if (line?.dataPoints?.length > 0) {
          tempDatasets.push({
            label: line?.lineName,
            data: line?.dataPoints?.map((point) => point?.value),
            borderColor: "rgb(53, 162, 235)",
            backgroundColor: "rgba(53, 162, 235, 0.5)",
            tension: 0,
            fill: false,
            pointBackgroundColor: "white",
            pointBorderColor: "rgb(53, 162, 235)",
            pointBorderWidth: 2,
            pointRadius: 4,

            ...(line.isDashed && {
              borderDash: [5, 5],
            }),
          });
        }
      });

      setDatasets(tempDatasets);

      const tempLabels = data?.lines?.flatMap(
        (line) => line?.dataPoints?.map((point) => point?.label) || []
      );

      setLabels(tempLabels);
    }
  }, [data]);
  // const dummyData2 = [135000, 142000, 138000, 130000, 143000, 158000, 130000];
  const dummyLabels = [
    "01-01-23",
    "01-02-23",
    "01-03-23",
    "01-04-23",
    "01-05-23",
    "01-06-23",
    "01-07-23",
  ];

  // // Use memoized values to prevent recreation on every render
  // const finalData = useMemo(() => externalData || dummyData, [externalData]);
  // const finalData2 = useMemo(() => externalData || dummyData2, [externalData]);
  const finalLabels = useMemo(
    () => externalLabels || dummyLabels,
    [externalLabels]
  );

  // externalDatasets.forEach(dataset => {
  //   datasets.push({
  //     label: 'Revenue',
  //     data: finalData,
  //     borderColor: 'rgb(53, 162, 235)',
  //     backgroundColor: 'rgba(53, 162, 235, 0.5)',
  //     tension: 0,
  //     fill: false,
  //     pointBackgroundColor: 'white',
  //     pointBorderColor: 'rgb(53, 162, 235)',
  //     pointBorderWidth: 2,
  //     pointRadius: 4,
  //   })
  // });

  // Define chart data structure
  const chartData = {
    labels: labels,
    datasets: datasets,
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
       labels: {
        boxWidth: 20,
        boxHeight:8,
        fontSize: 10,
        padding: 10,
        usePointStyle: true, 
      },
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        padding: 10,
        cornerRadius: 6,
        callbacks: {
          label: (context) => `Amount: ${context.parsed.y.toLocaleString()}`,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: true,
          color: "rgba(0, 0, 0, 0.05)",
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
          color: "rgba(0, 0, 0, 0.05)",
        },
        ticks: {
          callback: (value) => value.toLocaleString(),
        },
      },
    },
  };

  return (
    <div className={classes.chartContainer} style={{ height: `${height}px` }}>
      {loading ? (
        <div className={classes.loadingContainer}>
          <div className={classes.loadingSpinner}></div>
          <p>Loading chart data...</p>
        </div>
      ) : datasets?.length === 0 ? (
        <div className={classes.noDataContainer}>
          <p>No data available to display</p>
        </div>
      ) : (
        <div>
          <Line data={chartData} options={options} />
          <div className={classes.legendContainer}></div>
        </div>
      )}
    </div>
  );
};

export default Chart;
